import state from './moduleIntroState.js'
import mutations from './moduleIntroMutations.js'
import actions from './moduleIntroActions.js'
import getters from './moduleIntroGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
